import React, { PureComponent } from "react";
import { ProductSummary } from "~/action-panel/components/common/product-blend-summary/product-summary";

export class EventApplicationSummary extends PureComponent {
    render() {
        return <ProductSummary isEvent={true} isEquation={false} />;
    }
}
